import axios from 'axios'
import qs from 'qs'
import fn from '../../utils/functions'

function initSession () {
  const session = {
    listSelectedFiltersEmittedPayrolls: [],
    listSelectedFiltersReceivedPayrolls: [],
    listSelectedFiltersThirdPayrolls: [],
    optionsFilterInvoiceStatus: [],
    optionsFilterParty: [],
    optionsFilterChannel: [],
    optionsFilterFormatDocumentType: [],
    optionsFilterInvoiceClasses: [],
    optionsFilterInvoiceTaxType: [],
    optionsFilterCurrency: [],
    optionsFilterInvoiceType: [],
    optionsFilterInvoiceEmitBuyer: [],
    optionsFilterInvoiceEmitSeller: [],
    optionsFilterSignature: [],
    optionsFilterInvoiceReceiveBuyer: [],
    optionsFilterInvoiceReceiveSeller: [],
    optionsFilterInvoiceReceiveThird: [],
    optionsFilterPartyCentresOrderByEnabled: [],
    optionsFilterService: [],
    optionsFilterInvoiceSendMethods: [],
    optionsFilterInvoiceReceiveMethods: [],
    optionsFilterRecepctionMethods: [],
    optionsAccountingCloseStatus: [],
    optionsFilterProjectConfiguration: [],
    optionsFilterCommunicationsMethods: [],
    optionsFilterMediaType: [],
    optionsFilterMailType: [],
    optionsFilterPaymentMethod: [],
    optionsFilterUserHostServer: [],

  }
  return session
}

const state = {
  local: {
  },
  session: initSession()
}

const actions = {
  async isNewVersionFiltrosLocalState ({ state }, localStorage) {
    const isnew = await fn.isNewVersion(state, localStorage.facturas)
    return isnew
  },
  /**
     * Servicio para llenar Select Filtro Empresas
     */
  async getOptionsFilterParty ({
    commit, rootState
  }, data) {
    try {
      if (rootState.session.jwt !== null) {
        axios.defaults.headers.common.Authorization = rootState.session.jwt
      }

      const response = await axios({
        method: 'GET',
        url: '/party',
        params: data,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      const optionsFilterParty = response.data.content
      commit('OPTIONS_FILTER_PARTY_STATE', optionsFilterParty)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsFilterParty
    } catch (error) {
      console.log('/party: ', error)
      throw error.response
    }
  },
  /**
   * Obtiene las categorias que no están asignadas al servicio
   * @param {*} param0
   * @param {*} projectId
   */
  async getOptionsProjectCategory ({ commit, rootState }, projectId) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/me/project/' + projectId + '/categoriesnoadded'
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para llenar Select Filtro Estado de Facturas
     */
  async getOptionsFilterInvoiceStatus ({
    commit, rootState
  }, request) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/invoicestatus',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: request
      })

      const optionsFilterStatus = response.data
      commit('OPTIONS_FILTER_INVOICE_STATUS_STATE', optionsFilterStatus)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsFilterStatus
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
   * Servicio para llenar Select tipos de Email
   */
  async getOptionsEmailType ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/mailtype',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      commit('OPTIONS_FILTER_MAILTYPE', response.data)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR getOptionsEmailType --- ', error.response)
      throw error.response
    }
  },
  /**
   * Servicio para obtener los servidores de correo y cargarlos en el filtro
   */
  async getOptionsUserHostServer ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/mailServer'
      })

      commit('OPTIONS_FILTER_USERHOSTSERVER', response.data.content)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data.content
    } catch (error) {
      console.log('ERROR getOptionsUserHostServer --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para llenar Empresas de un proyecto se basa en las relaciones comerciales
     * Rellena los siguientes combos dependiendo de como este parametrizado
     * Combo de vendedores en facturas  EMITIDAS  BUYER
     * Combo de compradores en facturas RECIBIDAS SELLER
     *
     * Rol:SELLER-BUYER
     *
     */
  /* async getOptionsFilterPartyRelationCommercial ({
    commit, rootState
  }, request) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/me/partywithcommercialrelationship',
        params: request
      })

      let optionsFilterBuyer = ''
      let optionsFilterSeller = ''

      if (request.role === 'BUYER') {
        optionsFilterBuyer = response.data.content
        commit('OPTIONS_FILTER_INVOICE_EMIT_BUYER_STATE', optionsFilterBuyer)
      } else {
        optionsFilterSeller = response.data.content
        commit('OPTIONS_FILTER_INVOICE_RECEIVE_SELLER_STATE', optionsFilterSeller)
      }

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      if (request.role === 'BUYER') {
        return optionsFilterBuyer
      } else {
        return optionsFilterSeller
      }
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  }, */
  /**
     * Servicio para llenar Empresas de un proyecto se basa en las empresas de un usuario
     * Rellena los siguientes combos dependiendo de como este parametrizado
     * Combo de compradores en facturas EMITIDAS SELLER
     * Combo de vendedores en facturas RECIBIDAS BUYER
     *
     * Rol:SELLER-BUYER
     *
     */
  async getOptionsFilterPartyME ({
    commit, rootState
  }, request) {
    try {
      request.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        request.urlName = rootState.session.urlIn
      }

      const response = await axios({
        method: 'GET',
        url: '/me/party',
        params: request,
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      let optionsFilterBuyer = ''
      let optionsFilterSeller = ''
      let optionsFilterSignature = ''

      if (request.role === 'BUYER') {
        optionsFilterBuyer = response.data.content
        commit('OPTIONS_FILTER_INVOICE_RECEIVE_BUYER_STATE', optionsFilterBuyer)
        commit('OPTIONS_FILTER_INVOICE_DRAFT_BUYER_STATE', optionsFilterBuyer)
        commit('OPTIONS_NEW_INVOICE_BUYER_STATE', optionsFilterBuyer)
        commit('OPTIONS_FILTER_RECEIVER_AUDITS_STATE', optionsFilterBuyer)
      } else if (request.role === 'SELLER') {
        optionsFilterSeller = response.data.content
        commit('OPTIONS_FILTER_INVOICE_EMIT_SELLER_STATE', optionsFilterSeller)
        commit('OPTIONS_FILTER_INVOICE_DRAFT_SELLER_STATE', optionsFilterSeller)
        commit('OPTIONS_NEW_INVOICE_SELLER_STATE', optionsFilterSeller)
        commit('OPTIONS_FILTER_EMITTER_AUDITS_STATE', optionsFilterSeller)
      } else {
        optionsFilterSignature = response.data.content
        commit('OPTIONS_FILTER_SIGNATURE', optionsFilterSignature)
      }

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      if (request.role === 'BUYER') {
        return optionsFilterBuyer
      } else {
        return optionsFilterSeller
      }
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /*
   * Cuando se cambien todas las llamadas para apuntar a fenix-backend se debe borrar el método anterior
   */
  async getOptionsFilterPartyMEFenixBackend ({
    commit, rootState
  }, request) {
    try {
      request.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        request.urlName = rootState.session.urlIn
      }

      const response = await axios({
        method: 'GET',
        url: '/me/party',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: request,
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      let optionsFilterBuyer = ''
      let optionsFilterSeller = ''
      let optionsFilterSignature = ''
      let optionsFilterThird = '' 

      if (request.emission) {
        if (request.role === 'BUYER') {
          optionsFilterBuyer = response.data.content
          commit('OPTIONS_FILTER_INVOICE_EMIT_BUYER_STATE', optionsFilterBuyer)
          if(request.appFrom && request.appFrom === 'B2bInfoFactura') {
            commit('OPTIONS_FILTER_INVOICE_DRAFT_BUYER_STATE', optionsFilterBuyer)
          }
        } else if (request.role === 'SELLER') {
          optionsFilterSeller = response.data.content
          if(!request.appFrom) {
            commit('OPTIONS_FILTER_INVOICE_EMIT_SELLER_STATE', optionsFilterSeller)
          }
          if(request.appFrom && request.appFrom === 'B2bInfoFactura') {
            commit('OPTIONS_FILTER_INVOICE_DRAFT_SELLER_STATE', optionsFilterSeller)
          }
          commit('OPTIONS_NEW_INVOICE_SELLER_STATE', optionsFilterSeller)
          commit('OPTIONS_FILTER_EMITTER_AUDITS_STATE', optionsFilterSeller)
        }        
      } else if (!request.emission) {
        if (request.role === 'BUYER') {
          optionsFilterBuyer = response.data.content
          commit('OPTIONS_FILTER_INVOICE_RECEIVE_BUYER_STATE', optionsFilterBuyer)
          commit('OPTIONS_FILTER_INVOICE_DRAFT_BUYER_STATE', optionsFilterBuyer)
          commit('OPTIONS_NEW_INVOICE_BUYER_STATE', optionsFilterBuyer)
          commit('OPTIONS_FILTER_RECEIVER_AUDITS_STATE', optionsFilterBuyer)
        } else if (request.role === 'SELLER') {
          optionsFilterSeller = response.data.content
          commit('OPTIONS_FILTER_INVOICE_RECEIVE_SELLER_STATE', optionsFilterSeller)
          commit('OPTIONS_FILTER_INVOICE_DRAFT_SELLER_STATE', optionsFilterSeller)
          commit('OPTIONS_FILTER_EMITTER_AUDITS_STATE', optionsFilterSeller)
        } else if (request.role === 'THIRD') {
          optionsFilterThird = response.data.content
          commit('OPTIONS_FILTER_INVOICE_RECEIVE_THIRD_STATE', optionsFilterThird)
        }    
      } else {
          optionsFilterSignature = response.data.content
          commit('OPTIONS_FILTER_SIGNATURE', optionsFilterSignature)
      }

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      if (request.role === 'BUYER') {
        return optionsFilterBuyer
      } else if (request.role === 'SELLER') {
        return optionsFilterSeller
      } else if (request.role === 'THIRD') {
        return optionsFilterThird
      }
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
   * TODO: NUevo servicio para rellenar los combos de empresa con los parametros nuevos de pedidos (rol centro)
   * 
   */
   async getOptionsFilterCentresOrderByEnabledFenixBackend ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/me/party/centreorderenabled',
        params: data
      })

      const optionsFilterPartyCentres = response.data
      commit('OPTIONS_FILTER_PARTYCENTRE_ORDERENABLED_SELLER_STATE', optionsFilterPartyCentres)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsFilterPartyCentres
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para llenar Select Filtro Canales
     */
  async getOptionsFilterChannel ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/me/channel',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      const optionsFilterChannel = response.data
      commit('OPTIONS_FILTER_CHANNEL_STATE', optionsFilterChannel)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsFilterChannel
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para llenar Select Filtro Formato tipo de
     * Documento.
     */
  async getOptionsFilterFormatDocumentType ({
    commit, rootState
  }, id) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/documenttype/' + id + '/format',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR getOptionsFilterFormatDocumentType --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para llenar Select Filtro Servicios de este Usuario
     */
  async getOptionsService ({
    commit, rootState
  }, data) {
    try {
      if (rootState.session.jwt !== null) {
        axios.defaults.headers.common.Authorization = rootState.session.jwt
      }
      data.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        data.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/me/project',
        params: data,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })
      console.log('estamos en getOptionsService')
      const optionsFilterService = response.data.content
      if (data.enabled) {
        commit('OPTIONS_SERVICES_ENABLED_STATE', optionsFilterService)
      } else {
        commit('OPTIONS_FILTER_SERVICE_AUDITS_STATE', optionsFilterService)
      }

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsFilterService
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  async getPersonalizations ({ rootState, commit }) {
    try {
      if (rootState.session.jwt !== null) {
        axios.defaults.headers.common.Authorization = rootState.session.jwt
      }
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined) {

        const response = await axios({
          method: 'GET',
          url: '/project/' + rootState.session.urlIn + '/personalization',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL
        })
        
        if (response.data.projectName) {
          commit('URL_IN_STATE', response.data.projectName)
        }

        fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
        return response
      }
    } catch (error){
      console.log('ERROR', error.response)
      throw error.response
    } 
  },
  /**
     * Servicio para llenar Select Filtro Clases de Facturas
     */
  async getOptionsInvoiceClasses ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/documentclass',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      const optionsFilterClasses = response.data
      commit('OPTIONS_FILTER_INVOICE_CLASSES_STATE', optionsFilterClasses)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsFilterClasses
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para llenar Select Filtro Métodos Envio Facturas
     * de este Usuario
     * /protocol
     */
  async getOptionsFilterInvoiceSendMethods ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/me/protocol',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          method: 'SEND',
          isResend: false,
          visibleAndNull: true,
          byProject: false
        }
      })

      const optionsFilterSendMethods = response.data
      commit('OPTIONS_FILTER_INVOICE_SEND_METHODS_STATE', optionsFilterSendMethods)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsFilterSendMethods
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para llenar Select Filtro Tipo de
     * Impuestos de Facturas
     */
  async getOptionsFilterInvoiceTaxType ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/taxtype',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      const optionsFilterInvoiceTaxType = response.data
      commit('OPTIONS_FILTER_INVOICE_TAX_TYPE_STATE', optionsFilterInvoiceTaxType)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsFilterInvoiceTaxType
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para llenar Select Filtro Tipo de
     * Moneda.
     */
  async getOptionsFilterCurrency ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/currency',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      const optionsFilterCurrency = response.data
      commit('OPTIONS_FILTER_CURRENCY_STATE', optionsFilterCurrency)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsFilterCurrency
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  async getOptionsFilterPaymentMethod ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/paymentmethod',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      const optionsFilterPaymentMethod = response.data
      commit('OPTIONS_FILTER_PAYMENT_METHOD_STATE', optionsFilterPaymentMethod)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsFilterPaymentMethod
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para llenar Select Filtro de listado de tipo de facturas registradas
     */
  async getOptionsFilterInvoiceType ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/invoicetype',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      const optionsFilterInvoiceTyp = response.data
      commit('OPTIONS_FILTER_INVOICE_TYPE_STATE', optionsFilterInvoiceTyp)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)

      return optionsFilterInvoiceTyp
    } catch (error) {
      console.log('ERROR getOptionsFilterInvoiceType --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para llenar Select Filtro Métodos Recibo Facturas
     * de este Usuario
     * /protocol
     */
  async getOptionsFilterInvoiceReceiveMethods ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/me/protocol',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          method: 'RECEIVE',
          isResend: false,
          onlyVisible: true,
          byProject: false
        }
      })

      const optionsFilterInvoiceReceiveMethods = response.data
      commit('OPTIONS_FILTER_INVOICE_RECEIVE_METHODS_STATE', optionsFilterInvoiceReceiveMethods)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsFilterInvoiceReceiveMethods
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  async searchOptionsAccountingCloseStatus ({ commit, rootState }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/accountingclosestatus'
      })

      const optionsAccountingCloseStatus = response.data
      commit('OPTIONS_FILTER_ACCOUNTING_CLOSE_STATE_MUTATION', optionsAccountingCloseStatus)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsAccountingCloseStatus
    } catch (error) {
      console.log('ERROR getOptionsAccountingCloseStatus --- ', error)
      throw error.response ? error.response : error
    }
  },
  /**
     * Servicio para llenar Select Filtro de configuraciones de proyectos
     */
  async getOptionsFilterProjectConfiguration ({ commit, state }) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/constant/projectconfiguration'
      })

      const optionsFilterProjectConfiguration = response.data
      commit('OPTIONS_FILTER_PROJECT_CONFIGURATION_STATE', optionsFilterProjectConfiguration)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return optionsFilterProjectConfiguration
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para llenar Select Filtro de métodos de comunicación
     */
  async getOptionsFilterCommunicationsMethods ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/constant/communicationsmethod',
        params: {
          type: data
        }
      })

      const optionsFilterCommunicationsMethods = response.data
      commit('OPTIONS_FILTER_COMMUNICATIONS_METHODS_STATE', optionsFilterCommunicationsMethods)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsFilterCommunicationsMethods
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para llenar Select Filtro de métodos de comunicación de un servicio
     */
  async getOptionsFilterCommunicationsMethodsParty ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + data.serviceId + '/communicationsmethods',
        params: {
          sender: data.sender
        }
      })

      const optionsFilterCommunicationsMethods = response.data
      commit('OPTIONS_FILTER_COMMUNICATIONS_METHODS_STATE', optionsFilterCommunicationsMethods)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsFilterCommunicationsMethods
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para llenar Select Filtro de media-type
     */
  async getOptionsFilterMediaType ({ commit, rootState }) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/constant/mediatype'
      })

      const optionsFilterMediaType = response.data
      commit('OPTIONS_FILTER_MEDIA_TYPE_STATE', optionsFilterMediaType)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsFilterMediaType
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para llenar Select Filtro de centre-roletype
     */
   async getOptionsFilterCentreRoleType ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/centre/' + data.centreId + '/centrerolenoadded',
        params: {
          buyer: data.buyer
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  optionsFilterPartyState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_PARTY_STATE', payload)
  },
  listSelectedFiltersEmittedPayrollsState: ({
    commit
  }, payload) => {
    commit('LIST_SELECTED_FILTERS_EMITTED_PAYROLLS_STATE', payload)
  },
  listSelectedFiltersReceivedPayrollsState: ({
    commit
  }, payload) => {
    commit('LIST_SELECTED_FILTERS_RECEIVED_PAYROLLS_STATE', payload)
  },
  listSelectedFiltersThirdPayrollsState: ({
    commit
  }, payload) => {
    commit('LIST_SELECTED_FILTERS_THIRD_PAYROLLS_STATE', payload)
  },
  optionsFilterInvoiceStatus: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_INVOICE_STATUS_STATE', payload)
  },
  optionsFilterInvoiceEmitBuyerState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_INVOICE_EMIT_BUYER_STATE', payload)
  },
  optionsFilterInvoiceEmitSellerState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_INVOICE_EMIT_SELLER_STATE', payload)
  },
  optionsFilterSignature: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_SIGNATURE', payload)
  },
  optionsFilterInvoiceReceiveBuyerState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_INVOICE_RECEIVE_BUYER_STATE', payload)
  },
  optionsFilterInvoiceReceiveSellerState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_INVOICE_RECEIVE_SELLER_STATE', payload)
  },
  optionsFilterInvoiceReceiveThirdState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_INVOICE_RECEIVE_THIRD_STATE', payload)
  },
  optionsFilterPartyCentresOrderByEnabledState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_PARTYCENTRE_ORDERENABLED_SELLER_STATE', payload)
  },
  optionsFilterChannel: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_CHANNEL_STATE', payload)
  },
  optionsFilterFormatDocumentType: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_FORMAT_DOCUMENT_TYPE_STATE', payload)
  },
  optionsFilterServiceState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_SERVICE_AUDITS_STATE', payload)
  },
  optionsFilterInvoiceClasses: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_INVOICE_CLASSES_STATE', payload)
  },
  optionsFilterInvoiceSendMethods: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_INVOICE_SEND_METHODS_STATE', payload)
  },
  optionsFilterInvoiceTaxType: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_INVOICE_TAX_TYPE_STATE', payload)
  },
  optionsFilterCurrency: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_CURRENCY_STATE', payload)
  },
  optionsFilterInvoiceReceiveMethods: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_INVOICE_RECEIVE_METHODS_STATE', payload)
  },
  optionsFilterMailType: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_MAILTYPE', payload)
  },
  optionsFilterUserHostServerState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_USERHOSTSERVER', payload)
  },
  optionsFilterPaymentMethod: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_PAYMENT_METHOD_STATE', payload)
  }
}

const mutations = {
  resetSessionFiltros (state) {
    state.session = initSession()
  },
  'OPTIONS_FILTER_PARTY_STATE' (state, payload) {
    state.local.optionsFilterParty = payload
  },
  'LIST_SELECTED_FILTERS_EMITTED_PAYROLLS_STATE' (state, payload) {
    state.session.listSelectedFiltersEmittedPayrolls = payload
  },
  'LIST_SELECTED_FILTERS_RECEIVED_PAYROLLS_STATE' (state, payload) {
    state.session.listSelectedFiltersReceivedPayrolls = payload
  },
  'LIST_SELECTED_FILTERS_THIRD_PAYROLLS_STATE' (state, payload) {
    state.session.listSelectedFiltersThirdPayrolls = payload
  },
  'OPTIONS_FILTER_INVOICE_STATUS_STATE' (state, payload) {
    state.session.optionsFilterInvoiceStatus = payload
  },
  'OPTIONS_FILTER_INVOICE_EMIT_BUYER_STATE' (state, payload) {
    state.session.optionsFilterInvoiceEmitBuyer = payload
  },
  'OPTIONS_FILTER_INVOICE_EMIT_SELLER_STATE' (state, payload) {
    state.session.optionsFilterInvoiceEmitSeller = payload
  },
  'OPTIONS_FILTER_SIGNATURE' (state, payload) {
    state.session.optionsFilterSignature = payload
  },
  'OPTIONS_FILTER_INVOICE_RECEIVE_BUYER_STATE' (state, payload) {
    state.session.optionsFilterInvoiceReceiveBuyer = payload
  },
  'OPTIONS_FILTER_INVOICE_RECEIVE_SELLER_STATE' (state, payload) {
    state.session.optionsFilterInvoiceReceiveSeller = payload
  },
  'OPTIONS_FILTER_INVOICE_RECEIVE_THIRD_STATE' (state, payload) {
    state.session.optionsFilterInvoiceReceiveThird = payload
  },
  'OPTIONS_FILTER_PARTYCENTRE_ORDERENABLED_SELLER_STATE' (state, payload) {
    state.session.optionsFilterPartyCentresOrderByEnabled = payload
  },
  'OPTIONS_FILTER_PARTYCENTRE_DELIVERYNOTE_STATE' (state, payload) {
    state.session.optionsFilterPartyCentresDeliveryNoteByEnabled = payload
  },  
  'OPTIONS_FILTER_CHANNEL_STATE' (state, payload) {
    state.session.optionsFilterChannel = payload
  },
  'OPTIONS_FILTER_SERVICE_AUDITS_STATE' (state, payload) {
    state.session.optionsFilterService = payload
  },
  'OPTIONS_FILTER_INVOICE_CLASSES_STATE' (state, payload) {
    state.session.optionsFilterInvoiceClasses = payload
  },
  'OPTIONS_FILTER_INVOICE_SEND_METHODS_STATE' (state, payload) {
    state.session.optionsFilterInvoiceSendMethods = payload
  },
  'OPTIONS_FILTER_INVOICE_TAX_TYPE_STATE' (state, payload) {
    state.session.optionsFilterInvoiceTaxType = payload
  },
  'OPTIONS_FILTER_CURRENCY_STATE' (state, payload) {
    state.session.optionsFilterCurrency = payload
  },
  'OPTIONS_FILTER_INVOICE_TYPE_STATE' (state, payload) {
    state.session.optionsFilterInvoiceType = payload
  },
  'OPTIONS_FILTER_INVOICE_RECEIVE_METHODS_STATE' (state, payload) {
    state.session.optionsFilterInvoiceReceiveMethods = payload
  },
  'OPTIONS_FILTER_RECEPTION_METHODS_STATE' (state, payload) {
    state.session.optionsFilterRecepctionMethods = payload
  },
  'OPTIONS_FILTER_ACCOUNTING_CLOSE_STATE_MUTATION' (state, payload) {
    state.session.optionsAccountingCloseStatus = payload
  },
  'OPTIONS_FILTER_PROJECT_CONFIGURATION_STATE' (state, payload) {
    state.session.optionsFilterProjectConfiguration = payload
  },
  'OPTIONS_FILTER_COMMUNICATIONS_METHODS_STATE' (state, payload) {
    state.session.optionsFilterCommunicationsMethods = payload
  },
  'OPTIONS_FILTER_MEDIA_TYPE_STATE' (state, payload) {
    state.session.optionsFilterMediaType = payload
  },
  'OPTIONS_FILTER_MAILTYPE' (state, payload) {
    state.session.optionsFilterMailType = payload
  },
  'OPTIONS_FILTER_PAYMENT_METHOD_STATE' (state, payload) {
    state.session.optionsFilterPaymentMethod = payload
  },
  'OPTIONS_FILTER_USERHOSTSERVER' (state, payload) {
  state.session.optionsFilterUserHostServer = payload
  }
}

const getters = {
  listSelectedFiltersEmittedPayrolls: state => {
    return state.session.listSelectedFiltersEmittedPayrolls
  },
  listSelectedFiltersReceivedPayrolls: state => {
    return state.session.listSelectedFiltersReceivedPayrolls
  },
  listSelectedFiltersThirdPayrolls: state => {
    return state.session.listSelectedFiltersThirdPayrolls
  },
  optionsFilterInvoiceStatus: state => {
    return state.session.optionsFilterInvoiceStatus
  },
  optionsFilterInvoiceEmitBuyer: state => {
    return state.session.optionsFilterInvoiceEmitBuyer
  },
  optionsFilterInvoiceEmitSeller: state => {
    return state.session.optionsFilterInvoiceEmitSeller
  },
  optionsFilterSignature: state => {
    return state.session.optionsFilterSignature
  },
  optionsFilterInvoiceReceiveBuyer: state => {
    return state.session.optionsFilterInvoiceReceiveBuyer
  },
  optionsFilterInvoiceReceiveSeller: state => {
    return state.session.optionsFilterInvoiceReceiveSeller
  },
  optionsFilterInvoiceReceiveThird: state => {
    return state.session.optionsFilterInvoiceReceiveThird
  },
  optionsFilterPartyCentresOrderByEnabled: state => {
    return state.session.optionsFilterPartyCentresOrderByEnabled
  },
  optionsFilterChannel: state => {
    return state.session.optionsFilterChannel
  },
  optionsFilterFormatDocumentType: state => {
    return state.session.optionsFilterFormatDocumentType
  },
  optionsFilterService: state => {
    return state.session.optionsFilterService
  },
  optionsFilterInvoiceClasses: state => {
    return state.session.optionsFilterInvoiceClasses
  },
  optionsFilterInvoiceSendMethods: state => {
    return state.session.optionsFilterInvoiceSendMethods
  },
  optionsFilterInvoiceTaxType: state => {
    return state.session.optionsFilterInvoiceTaxType
  },
  optionsFilterCurrency: state => {
    return state.session.optionsFilterCurrency
  },
  optionsFilterInvoiceType: state => {
    return state.session.optionsFilterInvoiceType
  },
  optionsFilterInvoiceReceiveMethods: state => {
    return state.session.optionsFilterInvoiceReceiveMethods
  },
  optionsAccountingCloseStatus: state => {
    return state.session.optionsAccountingCloseStatus
  },
  optionsFilterProjectConfiguration: state => {
    return state.session.optionsFilterProjectConfiguration
  },
  optionsFilterCommunicationsMethods: state => {
    return state.session.optionsFilterCommunicationsMethods
  },
  optionsFilterMediaType: state => {
    return state.session.optionsFilterMediaType
  },
  optionsFilterRecepctionMethods: state => {
    return state.session.optionsFilterRecepctionMethods
  },
  optionsFilterMailType: state => {
    return state.session.optionsFilterMailType
  },
  optionsFilterPaymentMethod: state => {
    return state.session.optionsFilterPaymentMethod
  },
  optionsFilterUserHostServer: state => {
    return state.session.optionsFilterUserHostServer
  },
}

export default {
  state,
  actions,
  mutations,
  getters
}
